import React, { useContext, useEffect } from "react";
import { MainContext } from "../App";
import functions from "../utilities/functions";
import { useAppStore } from "../useAppStore";

export default function Products() {
	const { category, animations, setAnimations, courses } = useContext(MainContext);
	const { src, srcProducts, setSrcProducts } = useAppStore();

	useEffect(() => {
		filter();
	}, [src]);

	useEffect(() => {
		for (const productId of animations) {
			const el = document.querySelector("[data-id='" + productId + "']");
			if (el) {
				el.classList.add("success");
				setAnimations(animations.slice(1));
				window.setTimeout(() => el.classList.remove("success"), 300);
			}
		}
	}, [animations]);

	function filter() {
		console.log("filter");
		let arr = [];
		if (src) {
			courses.map((course) =>
				course.categories.map((category) =>
					category.products.map((product) => {
						console.log(product.name, src, product.name.includes(src));
						if (product.name.toLowerCase().includes(src.toLowerCase()))
							arr.push(product);
					})
				)
			);
		}
		arr.sort(function (a, b) {
			return a["name"] > b["name"] ? 1 : -1;
		});
		setSrcProducts(arr);
	}

	return (
		<div className="scroll products-scroll">
			{src && srcProducts.map((prod, n) => <Product key={n} product={prod} />)}
			{!src &&
				category &&
				category.products.map((product, i) => <Product key={i} product={product} />)}
		</div>
	);
}

function Product({ product }) {
	const { handleAddProduct, setVariantsPopup, editQty, cart } = useContext(MainContext);

	const getQty = (productId) => {
		let qty = 0;
		for (const p of cart.products) {
			if (p.id == productId) qty += parseInt(p.qty);
		}
		return qty;
	};

	const handleEditProduct = (productId, type) => {
		const index = cart.products.findLastIndex((p) => p.id == productId);
		if (index > -1) editQty(index, type);
	};

	const openUnifiedProductSheet = () => {
		setVariantsPopup({
			product: { ...product, notes: product.notes || "" },
			index: false,
			fromProductSheet: true,
		});
	};

	return (
		<div
			className="list-button product-row"
			data-id={product.id}
			onClick={openUnifiedProductSheet}
		>
			<button
				className="product-name"
				onClick={(e) => {
					e.stopPropagation();
					openUnifiedProductSheet();
				}}
			>
				{product.name}
				<div className="small">
					{functions.formatter.format(product.price)}
					{product.stock !== false && (
						<span
							className={
								typeof product.stock === "number" && product.stock <= 0
									? "stock-empty"
									: ""
							}
						>
							{" "}
							- Rimanenti: {product.stock} pezzi
						</span>
					)}
				</div>
			</button>
			<div className="product-row-actions">
				<div className="plus_minus_container product-qty-controls">
					<button
						className={
							"btn btn-square" + (getQty(product.id) > 0 ? " btn-primary" : "")
						}
						onClick={(e) => {
							e.stopPropagation();
							handleEditProduct(product.id, "minus");
						}}
					>
						&#8722;
					</button>
					<div className="product-qty-value">{getQty(product.id)}</div>
					<button
						className="btn btn-primary btn-square"
						onClick={(e) => {
							e.stopPropagation();
							handleAddProduct(product);
						}}
					>
						&#43;
					</button>
				</div>
			</div>
		</div>
	);
}
